module.exports = __webpack_public_path__ + "img/tab_bg_active.df53f767.svg";